/**
 * plaster_material — the LIT lime plaster (shader gaps, 2026-09-30: the EON round's open item).
 *
 * Settlement interiors are unlit by law (interiors.md: INTERIOR MATERIALS ARE UNLIT), so the only plaster a diffuse
 * model reaches is the shell of the personal-world homes (`PersonalPresetModule.buildHome`, `wall: 'plaster'`). One
 * builder, shared by that module and the material bed (`probe/material_models_bed.ts` subject 2e), so the bed pictures
 * the material the world draws.
 *
 * With the `eonDiffuse` flag (med / high / ultra; kill `atlas:eon`) the plaster wears the engine's EON rough diffuse in
 * the 'white' colour mode — the albedo kept exactly, so the white furnace returns Lambert's picture and only the
 * directional response changes (flatter under a sun behind the viewer, darker at a grazing side light).
 */
import * as THREE from 'three/webgpu';
import { applyEONDiffuse } from 'enginex/render/materials/EONDiffuse.js';
import { EON_PLASTER_ROUGHNESS, eonDiffuseOn, materialModelStats } from './material_models.js';

/** The plaster shell's surface (the texture set binds later — PersonalPresetModule.bindSet). */
export function buildPlasterMaterial(color: THREE.ColorRepresentation, models: { eon: boolean } = { eon: eonDiffuseOn() }): THREE.MeshStandardMaterial {
  const m = new THREE.MeshStandardMaterial({ color, roughness: 0.62, metalness: 0.05 });
  if (models.eon && EON_PLASTER_ROUGHNESS > 0 && applyEONDiffuse(m, { roughness: EON_PLASTER_ROUGHNESS, colorMode: 'white' }).applied) {
    materialModelStats.eonPlaster++;
  }
  return m;
}
